import { createI18n } from 'vue-i18n'
import enTranslation from '@/i18n/en.json'
import ptTranslation from '@/i18n/pt.json'

const i18n = createI18n({
  locale: 'pt',
  fallbackLocale: 'en',
  messages: {
    pt: ptTranslation,
    en: enTranslation
  }
})

export default i18n
